import React, { useContext, useEffect, useState } from "react";
import Sidebar from "../../comman_page/Sidebar";
import { HeaderDashboard } from "../../comman_page/HeaderDashboard";
import { Container, Row, Col, Spinner, Modal, Button, Card } from "react-bootstrap";
import { Footer } from "antd/es/layout/layout";
import { SharedButton } from "../../../../../sharedComponents/Button";
import { BsCartPlusFill } from "react-icons/bs";
import { ProductCardList } from "../../../../../sharedComponents/ProductCardList";
import { PurchaseMembershipCard } from "../../../../../sharedComponents/PurchaseMembershipCard";
import { add_cart, add_free_pass, cardGet_Studio_New, cart_list, clover_studio_buy_now_single_API, getSaveCard, passes_details_API, search_customer_details } from "../../../../../Studio-Services/Studio_Services";
import { MyContext } from "../../../../../App";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import logo from "../../../../../Images/logo_white_web.png"
import { MemberProductCart } from "../../../../../sharedComponents/MemberProductCart";
import { errorAlert, successAlert } from "../../../../../Static_Services/Alertmsg";
import { ExpiryCheck } from "../../../../../Static_Services/Staff_Services";


export const PurchaseProduct = () => {
  const navigate = useNavigate();

  const [timePass, setTimePass] = useState([]);
  const [punchPass, setPunchPass] = useState([]);
  const [recurringPass, setRecurringPass] = useState([]);
  const [passValueRecurring, setPassValueRecurring] = useState([]);
  const [passValueTimeFram, setPassValueTimeFram] = useState([]);
  const [passValuePunch, setassValuePunch] = useState([]);


  const [loader, setLoader] = useState(false);


  const [purchasetimePass, setPurchaseTimePass] = useState([]);
  const [purchasepunchPass, setPurchasePunchPass] = useState([]);
  const [purchaserecurringPass, setPurchaseRecurringPass] = useState([]);

  const [purchasepassValueRecurring, setPurchasePassValueRecurring] = useState([]);
  const [purchasepassValueTimeFram, setPurchasePassValueTimeFram] = useState([]);
  const [purchasepassValuePunch, setPurchaseassValuePunch] = useState([]);

  const [nodata, setNodata] = useState(0);


  const location = useLocation();
  const context = useContext(MyContext);

  const [userData, setUserData] = useState([]);
  const [clientID, setClientID] = useState();
  const [costmoreData, setCostmoreData] = useState();
  const [customerDetails, setCustomerDetails] = useState([]);
  const [cartLists, setCartLists] = useState();
  const [familyMember, setFamilyMember] = useState([]);

  const [finalClientId, setFinalClientId] = useState();
  const [family_member_id, setFamily_member_id] = useState();
  const [isPassPurchaseFlow, setIsPassPurchaseFlow] = useState(false);
  const [preClassID, setPreClassID] = useState();
  const [preSchedule_id, setPreSchedule_id] = useState();
  const [recurringPunch, setRecurringPunch] = useState([]);


  // const cltID = sessionStorage.getItem("clientid");


  useEffect(() => {
    if (location && location.state && location.state.data && location.state.data.id) {
      setClientID(location.state.data.id);
      clientSelect(location.state.data, '', 2);
      setPreClassID();
      setPreSchedule_id();
      setIsPassPurchaseFlow(false);
      localStorage.removeItem('st_isPassPurchaseFlow');
      if (!location.state.family_member_id) {
        localStorage.removeItem('memberUserId');
      }
      localStorage.removeItem('allsetData');
    } else if (location && location.state && location.state.data && location.state.data.data && location.state.data.data.id) {
      setClientID(location.state.data.data.id);
      // familyHandler(location.state.family_member_id) //////////////////////////////////////////////////////////////////Meemmmbar Function
      setFamily_member_id(location.state.family_member_id);
      if (location.state.family_member_id) {
        localStorage.setItem('memberUserId', location.state.family_member_id);
      } else { localStorage.removeItem('memberUserId'); }
      clientSelect(location.state.data.data, location.state.class_id);
      setPreClassID(location.state.class_id);
      setPreSchedule_id(location.state.schedule_id);
      if (JSON.parse(localStorage.getItem('st_isPassPurchaseFlow'))) {
        setIsPassPurchaseFlow(true);
      }
    }
  }, [location])

  // useEffect(() => {
  //   localStorage.removeItem('memberUserId');
  // }, [])

  const clientSelect = async (data, class_id, checkFamily = 1) => {
    let request = {
      "client_id": data.id,
      "class_id": class_id
    }
    const response = await search_customer_details(request);
    if (response) {
      setCostmoreData(response.data.data);
      localStorage.setItem('st_customerDetails', JSON.stringify(response.data.data));
      setFinalClientId(response.data.data.id);
      // setCurrentPassesRecord();
    } else {
      setCostmoreData('');
      localStorage.removeItem('st_customerDetails');
      setFinalClientId('');
    }
  }

  const back = () => {
    if (isPassPurchaseFlow && preClassID != '') {
      navigate('/client-search', { state: { back: 'pre', class_id: preClassID, schedule_id: preSchedule_id, serchKey: JSON.parse(localStorage.getItem('st_searchedClients')) } });
    } else {
      navigate('/make-a-purchase');
    }
  }

  const cartList = async () => {
    const fData = {
      "pageid": "1",
      "client_id": family_member_id ? family_member_id : costmoreData.id
    }
    const resp = await cart_list(fData);
    if (resp) {
      setCartLists(resp.data.data);
    } else setCartLists([]);
    const Cosdata = {
      "customer": costmoreData.id
    }

    const resp1 = await search_customer_details(Cosdata);
    if (resp1) {
      setCustomerDetails(resp1.data.data);
    }
  }

  const familyHandler = async (e) => {
    if (e.target.value.length === 0) {
      localStorage.removeItem('memberUserId');
    } else {
      localStorage.setItem('memberUserId', e.target.value);
    }
    let customerId = (e.target.value.length > 0) ? e.target.value : costmoreData.id;
    setFamily_member_id(customerId);
    const fData = {
      "pageid": "1",
      "client_id": customerId
    }
    const resp = await cart_list(fData);
    if (resp) {
      setCartLists(resp.data.data);
    } else setCartLists([]);
  }

  const setOptions = () => {
    const mbr = [];
    if (costmoreData.family_member) {
      (costmoreData.family_member).map((e) => (
        mbr.push({
          value: e.id, label: `Name :- ${e.member_name} , Relation: ${e.relation}`
        })
      ))
      setFamilyMember(mbr);
    } else setFamilyMember([]);
  }



  const [dCode, setDCode] = useState();
  const [discountAmount, setDiscountAmount] = useState();
  const [discountedAmount, setDiscountedAmount] = useState();
  const [applied_code, setApplied_code] = useState();
  const [orgPassDetail, setOrgPassDetail] = useState();
  const [passDetail, setPassDetail] = useState();
  const [rPassDetails, setRPassDetails] = useState(false);
  const [cardType, setCardType] = useState();
  const [saveCard, setSaveCard] = useState(0);

  const [cardError, setCardError] = useState({ name: "", crdNumber: "", dates: "", cvv: "" });
  const [cardData, setCardData] = useState({ name: "", crdNumber: "", dates: "", cvv: "" });
  const CardInputChange = (e) => {
    const { name, value } = e.target;
    const cleanedValue = value.replace(/^\s+/g, '');
    setCardData((pre) => ({ ...pre, [name]: cleanedValue }));
    setCardError((pre) => ({ ...pre, [name]: "" }));
  }
  const [expiryDate, setExpiryDate] = useState();

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    if (e.nativeEvent.inputType === "deleteContentBackward") {
      if (inputValue.endsWith('/')) {
        setExpiryDate(inputValue.slice(0, -1));
      } else { setExpiryDate(inputValue); }
    } else {
      if (inputValue.length === 2 && inputValue.charAt(2) !== '/') {
        setExpiryDate(inputValue + '/');
      } else if (inputValue.length === 8) { return; } else { setExpiryDate(inputValue); }
    }
  };



  const passList = async () => {
    const timefram = [];
    const punchfram = [];
    const recuring = [];
    const RcPunch = [];
    if (costmoreData && costmoreData.avaliable_passes_data) {
      const fData = costmoreData.avaliable_passes_data;
      fData.map((e) => (
        e.pass_type === "Time Frame" ?
          timefram.push({
            pass_id: e.id,
            service_type: "1",
            quantity: "1",
            memberShipImg: e.studio_logo ? e.studio_logo : "",
            cardTitle: e.pass_name,
            price: e.amount,
            validText: `Valid For ${e.pass_days} Days`,
            taxTaxt: "Plus Tax",
            isAutoAdd: e?.isAutoAdd,
            is_recurring_billing: e?.is_recurring_billing,
          })
          : e.pass_type === "Recurring Membership" ?
            recuring.push({
              pass_id: e.id,
              memberShipImg: e.studio_logo ? e.studio_logo : "",
              cardTitle: e.pass_name,
              price: e.amount,
              service_type: "1",
              quantity: "1",
              validText: `Valid For ${e.pass_days} Days`,
              taxTaxt: "Plus Tax",
              isAutoAdd: e?.isAutoAdd,
              is_recurring_billing: e?.is_recurring_billing,
            })
            : e.pass_type === "Punch Card" ?
              e?.is_recurring_billing == 'yes' ?
                RcPunch.push({
                  pass_id: e.id,
                  memberShipImg: e.studio_logo ? e.studio_logo : "",
                  cardTitle: e.pass_name ? e.pass_name : "",
                  price: e.amount ? e.amount : "",
                  service_type: "1",
                  quantity: "1",
                  validText: `Valid For ${e.pass_days} Classes`,
                  taxTaxt: "Plus Tax",
                  isAutoAdd: e?.isAutoAdd,
                  is_recurring_billing: e?.is_recurring_billing,
                })
                : punchfram.push({
                  pass_id: e.id,
                  memberShipImg: e.studio_logo ? e.studio_logo : "",
                  cardTitle: e.pass_name ? e.pass_name : "",
                  price: e.amount ? e.amount : "",
                  service_type: "1",
                  quantity: "1",
                  validText: `Valid For ${e.pass_days} Classes`,
                  taxTaxt: "Plus Tax",
                  isAutoAdd: e?.isAutoAdd,
                  is_recurring_billing: e?.is_recurring_billing,
                })
              : ""
      ))
      setTimePass(timefram);
      setPunchPass(punchfram);
      setRecurringPass(recuring);
      setRecurringPunch(RcPunch);
    }

    const Purchase_timefram = [];
    const Purchase_recuring = [];
    const Purchase_punchfram = [];

    if (costmoreData && costmoreData.purchase_passes_data) {
      const purchaseData = costmoreData.purchase_passes_data;

      purchaseData.map((e) => (
        e.pass_type_name === "Time Frame" ?
          Purchase_timefram.push({
            pass_id: e.id,
            service_type: "1",
            quantity: "1",
            memberShipImg: e.business_logo ? e.business_logo : "",
            cardTitle: e.pass_name,
            price: e.amount,
            startDate: `Start Date  ${e.start_date}`,
            taxTaxt: "Plus Tax",
            is_recurring_billing: e?.is_recurring_billing,
          })
          : e.pass_type_name === "Recurring Membership" ?
            Purchase_recuring.push({
              pass_id: e.id,
              memberShipImg: e.business_logo ? e.business_logo : "",
              cardTitle: e.pass_name,
              price: e.amount,
              service_type: "1",
              quantity: "1",
              startDate: `Start Date  ${e.start_date}`,
              taxTaxt: "Plus Tax",
              is_recurring_billing: e?.is_recurring_billing,
            })
            : e.pass_type_name === "Punch Card" ?
              Purchase_punchfram.push({
                pass_id: e.id,
                memberShipImg: e.business_logo ? e.business_logo : "",
                cardTitle: e.pass_name ? e.pass_name : "",
                price: e.amount ? e.amount : "",
                service_type: "1",
                quantity: "1",
                startDate: `Start Date  ${e.start_date}`,
                taxTaxt: "Plus Tax",
                is_recurring_billing: e?.is_recurring_billing,
              })
              : ""
      ))

      setPurchaseTimePass(Purchase_timefram);
      setPurchaseRecurringPass(Purchase_recuring);
      setPurchasePunchPass(Purchase_punchfram);
    }
  }

  useEffect(() => {
    if (costmoreData) {
      setOptions();
      cartList();
      passList();
    }
  }, [costmoreData])

  const recuringHandler = (data) => {
    setPassValueRecurring(data);
  }

  const timeFramHandler = (data) => {
    setPassValueTimeFram(data);
  }

  const punchHandler = (data) => {
    setassValuePunch(data)
  }

  // Puchasss

  const purchaserecuringHandler = (data) => {
    setPurchasePassValueRecurring(data);
  }

  const purchasetimeFramHandler = (data) => {
    setPurchasePassValueTimeFram(data);
  }

  const purchasepunchHandler = (data) => {
    setPurchaseassValuePunch(data)
  }

  useEffect(() => {
    if (context.context !== undefined && context.context !== null) {
      const udata = context.context.uData;
      setUserData({
        business_img: udata.business_img,
        logo: udata.logo
      });
    }
  }, [context])


  const [customerData, setCustomerData] = useState([]);

  const getSaveCardDetail = async (id) => {
    setLoader(true);
    let payload = { "userid": id }
    const resp = await cardGet_Studio_New(payload);
    if (resp) {
      const response = resp.data;
      response.data.map((el) => {
        el.checked = true;
      })
      setCustomerData(response.data);
      setLoader(false);
    } else {
      setLoader(false);
    }
  }

  // useEffect(() => {
  //   const client_id = family_member_id ? family_member_id : costmoreData.id;
  //   getSaveCardDetail(client_id);
  // }, [family_member_id, costmoreData])



  const addCart = async (service_type, data, quantity) => {

    if (data?.isAutoAdd == "Yes") {
      Swal.fire({
        title: "Are you sure?",
        text: "You are about to add this pass directly to the client profile. No checkout will be required.",
        imageUrl: logo, // your logo variable
        imageAlt: "Logo",
        showCancelButton: true,
        confirmButtonText: "Yes, add pass",
        cancelButtonText: "Cancel",
        customClass: {
          title: 'swal2-title-white',
          htmlContainer: 'swal2-text-white'
        },
        showClass: {
          popup: 'custom-dialog-container',
        },
        confirmButtonColor: "#28a745" // green for confirm
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            setLoader(true);
            const payload = {
              'service_type': data?.service_type,
              'service_id': data?.pass_id,
              'amount': data?.price,
              'quantity': 1,
              'client_id': family_member_id ? family_member_id : costmoreData.id,
            }
            const resp = await add_free_pass(payload);
            // resp.data.message
            if (resp) {
              Swal.fire({
                html: `
          <img src=${logo} class="img-fluid d-block mx-auto mt-5" />
          <h4 class="title text-capitalize text-center mt-4 textWhite">
             PASS ADDED SUCCESS
          </h4>
          <p class="text-center my-4 textcolor">
            <small class="textWhite">
              ${'Pass was successfully added to the client profile. No checkout is required.'}
            </small>
          </p>
          `,
                showClass: {
                  popup: 'custom-dialog-container',
                },
                customClass: {
                  confirmButton: 'custom-button custom-button-size modalbtn',
                },
              })
            }
          } catch (error) {
            console.error("@error------", error);
          } finally {
            setLoader(false);
          }
        }
      })
    } else if (data?.is_recurring_billing == "yes") {
      Swal.fire({
        html: `
          <img src="${logo}" class="img-fluid d-block mx-auto mt-5" />
          <h4 class="title text-capitalize text-center mt-4 textWhite">
            Notice
          </h4>
          <p class="text-center my-4 textcolor">
            <small class="textWhite">
              Recurring billing passes require a credit/debit card.
            </small>
          </p>
        `,
        showCancelButton: true,
        confirmButtonText: "Ok",
        cancelButtonText: "Back",
        showClass: {
          popup: "custom-dialog-container",
        },
        customClass: {

          confirmButton: "custom-button custom-button-size bg-white",
          cancelButton: "custom-button custom-button-size bg-white",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          setLoader(true);
          const payload = {
            'pass_id': data.pass_id,
            'client_id': family_member_id ? family_member_id : costmoreData.id,
            'user_booking_id': ''
          }
          const resp = await passes_details_API(payload);
          if (resp.status == 1) {
            setLoader(false);
            const cl_ID = family_member_id ? family_member_id : costmoreData.id;
            getSaveCardDetail(cl_ID);
            const api_response = resp.data;
            setOrgPassDetail(api_response);
            setPassDetail(api_response);
            setRPassDetails(true);
          } else {
            setLoader(false);
            Swal.fire({
              html: `<img src=${logo} class="img-fluid d-block mx-auto mt-5" />
          <h4 class="title text-capitalize text-center mt-4 textWhite">
          Error !!!
        </h4>
        <p class="text-center my-4 textcolor">
        <small class="textWhite">
       ${resp.message} </small></p>
        `,
              showClass: {
                popup: 'custom-dialog-container',
              },
              customClass: {
                confirmButton: 'custom-button custom-button-size modalbtn',
              },
            });
          }
          // Continue with the action
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          setRPassDetails(false);
          console.log("Back clicked");
          // Go back or do nothing
        }
      });

    } else {
      let fData = '';
      if (service_type === "3") {
        fData = {
          service_type: service_type,
          service_id: data.id,
          amount: data.amount,
          quantity: quantity,
          client_id: family_member_id ? family_member_id : costmoreData.id
        }
      } else {
        fData = {
          service_type: service_type,
          service_id: data.pass_id,
          amount: data.price,
          quantity: quantity,
          client_id: family_member_id ? family_member_id : costmoreData.id
        }
      }

      //    Add To Cart
      const resp = await add_cart(fData);
      if (resp) {
        cartList();
        Swal.fire({
          html: `
        <img src=${logo} class="img-fluid d-block mx-auto mt-5" />
        <h4 class="title text-capitalize text-center mt-4 textWhite">
          SUCCESS
        </h4>
        <p class="text-center my-4 textcolor">
          <small class="textWhite">
            ${resp.data.message}
          </small>
        </p>
        `,
          showClass: {
            popup: 'custom-dialog-container',
          },
          customClass: {
            confirmButton: 'custom-button custom-button-size modalbtn',
          },
        })
      }
    }
  }


  const handleApply = (pd) => {
    const discountList = pd?.discount_code ?? [];
    const pre = { ...pd }

    const mainData = orgPassDetail

    if (!dCode) {
      errorAlert("Please enter discount code");
      return;
    }
    const found = discountList.find(
      (d) =>
        d.code_name.toLowerCase().trim() ===
        dCode.toLowerCase().trim()
    );

    if (!found) {
      errorAlert("Invalid or already applied discount code.");
      return;
    }

    let baseAmount = parseFloat(mainData.amount);
    let discount = 0;
    setApplied_code(found);
    discount = (baseAmount * parseFloat(found.amount)) / 100;
    setDiscountAmount(discount.toFixed(2));
    let payable = baseAmount - discount;
    let tax1Amount = 0;
    let tax2Amount = 0;

    if (mainData?.pass_full_tex1 != '') {
      tax1Amount = (parseFloat(payable) * parseFloat(mainData?.pass_full_tex1)) / 100;
    }
    if (mainData?.pass_full_tex2 != '') {
      tax2Amount = (parseFloat(payable) * parseFloat(mainData?.pass_full_tex2)) / 100;
    }
    if (tax1Amount > 0) {
      payable = payable + tax1Amount;
    }
    if (tax2Amount > 0) {
      payable = payable + tax2Amount;
    }

    pre.tax1_rate = parseFloat(tax1Amount).toFixed(2);
    pre.tax2_rate = parseFloat(tax2Amount).toFixed(2);
    pre.pass_total_price = parseFloat(payable).toFixed(2);

    payable = parseFloat(payable).toFixed(2);

    setDiscountedAmount(payable);
    successAlert("Coupon applied successfully");
    setPassDetail(pre);
  };

  const [paymentVal, setPaymentVal] = useState(false);
  const getCardType = (event) => {
    setCardType(event.target.id);
    customerData.map((el) => {
      if (el.card_id == cardType) {
        el.checked = event.target.checked;
      }
    })
  }

  const savePayment = async (card) => {
    setLoader(true);
    const payload = {
      "service_type": '1',
      'client_id': family_member_id ? family_member_id : costmoreData.id,
      "service_id": passDetail.pass_id,
      "quantity": 1,
      "grand_total": discountedAmount ?? passDetail.pass_total_price,
      "slot_date": "",
      "slot_time_id": "",
      "token": card.card_token,
      "savecard": 0,
      "card_id": card.card_id,
      "country_code": "",
      'discount_amount': discountAmount,
      'discount_code': applied_code?.discount_code_id ?? '',
      'd_code_name': applied_code?.code_name ?? '',
    };
    const resp = await clover_studio_buy_now_single_API(payload);
    if (resp) {
      const response = resp.data;
      successAlert(response.message);
      setLoader(false);
      if (JSON.parse(localStorage.getItem('st_isPassPurchaseFlow'))) {
        let getFinale = JSON.parse(localStorage.getItem('allsetData'));
        navigate('/client-search', { state: { back: 'pre', class_id: getFinale.class_id, schedule_id: getFinale.schedule_id, serchKey: JSON.parse(localStorage.getItem('st_searchedClients')) } });
      } else {
        navigate("/make-a-purchase");
      }
    } else {
      setLoader(false);
    }
  }

  const SavecardHandeler = (event) => {
    if (event.target.checked == true) {
      setSaveCard(1);
    }
    else { setSaveCard(0) }
  }


  const paymentHandler = async () => {

    let isValid = 1;
    let expiry_month = '';
    let expiry_year = '';
    let expired = '';

    if (expiryDate) {
      expired = ExpiryCheck(expiryDate);
    }
    if (expired) {
      expiry_month = expired[0];
      expiry_year = expired[1];
    } else {
      setCardError((pre) => ({ ...pre, dates: "* Valid Till is required" }));
      isValid = 2;
    }

    if (!cardData.name) { setCardError((pre) => ({ ...pre, name: "* Card Holder Name is required" })); isValid = 3; };
    if (!cardData.crnumber) {
      setCardError((pre) => ({ ...pre, crnumber: "* Card Number is required" }))
      isValid = 4;
    };
    if (!cardData.cvv) {
      setCardError((pre) => ({ ...pre, cvv: "* CVV is required" }));
      isValid = 5;
    };
    if (isValid === 1) {
      setLoader(true);
      const detail = {
        "service_type": '1',
        'client_id': family_member_id ? family_member_id : costmoreData.id,
        "service_id": passDetail.pass_id,
        "quantity": 1,
        "grand_total": discountedAmount ?? passDetail.pass_total_price,
        "slot_date": "",
        "slot_time_id": "",
        "token": '',
        "savecard": saveCard,
        "card_id": '',
        // "business_id": businessDetail.business_id,
        "number": cardData.crnumber,
        "expiry_month": expiry_month,
        "expiry_year": expiry_year,
        "cvd": cardData.cvv,
        "country_code": "",
        "customer_name": cardData.name,
        'discount_amount': discountAmount,
        'discount_code': applied_code?.discount_code_id ?? '',
        'd_code_name': applied_code?.code_name ?? '',
      };
      const resp = await clover_studio_buy_now_single_API(detail);
      if (resp) {
        const response = resp.data;
        setCardData({ name: "", crnumber: "", dates: "", cvv: "" });
        successAlert(response.message);
        setLoader(false);
        if (JSON.parse(localStorage.getItem('st_isPassPurchaseFlow'))) {
          let getFinale = JSON.parse(localStorage.getItem('allsetData'));
          navigate('/client-search', { state: { back: 'pre', class_id: getFinale.class_id, schedule_id: getFinale.schedule_id, serchKey: JSON.parse(localStorage.getItem('st_searchedClients')) } });
        } else {
          navigate("/make-a-purchase");
        }
      } else {
        setCardData({ name: "", crnumber: "", dates: "", cvv: "" });
        setLoader(false);
      }
    } else {
      setLoader(false);
      return;
    }
  }


  return (
    <>
      {loader &&
        <div className='MainLoader'>
          <Spinner animation="border" role="status" className='Loader'>
          </Spinner>
        </div>}
      <div className="MainDashboard">
        <div className="MainLayout">
          <Row>
            <Sidebar />
            <Col>
              <div className="RightSide">
                <HeaderDashboard />

                <section className="addClient innerContent">
                  <SharedButton title={"Back"} onClick={() => back()} className={"BackButton"} />
                  <div className="AddClientContent">
                    <Container>
                      {nodata === 0 ?
                        <>
                          {
                            costmoreData
                              ?
                              <div className="PurchaseProfileProduct">
                                < img
                                  src={costmoreData.profile_img ? costmoreData.profile_img : "https://staging.warriorsms.com/superadmin/uploads/user/p.png"}
                                  alt=""
                                  className="purchaseDP img-fluid"
                                />
                                <div className="customerDetails">
                                  <h3>{costmoreData.name}</h3>
                                  <p>Customer</p>
                                  <p>{costmoreData.date_of_birth}</p>
                                  <p>{costmoreData.email}</p>
                                </div>
                              </div>
                              : ""}

                          <Row>
                            <Col md={6}>
                              <div className="form-group relative">
                                <p className="text-left font-14 mb-2 mt-3" style={{ fontWeight: '600', color: 'black' }}>Family Members  </p>
                                <select className="form-control white-color" name="family_member_id"
                                  onChange={familyHandler}>
                                  <option value=''>Select</option>
                                  {familyMember.length > 0 && familyMember.map((data) => (
                                    <>
                                      {/* <img src={data.image} alt=''/> */}
                                      <option value={data.value} selected={data.value === family_member_id}>{data.label}</option>
                                    </>
                                  ))}
                                </select>
                              </div>
                              {/* <SharedSelect
                              name="instructor"
                              lable={"FAMILY MEMBERS"}
                              options={familyMember}
                              value={family_member_id}
                              onChange={familyHandler}
                            /> */}
                            </Col>
                          </Row>

                          <Row className="my-5">
                            <Col>
                              <h4>Current Available Products</h4>

                            </Col>
                            <Col>
                              <SharedButton
                                title={cartLists && cartLists.total_item ? cartLists.total_item : ""}
                                iconNode={<BsCartPlusFill />}
                                onClick={() => { navigate('/cart', { state: { id: costmoreData.id, family_member_id: family_member_id } }); }}
                                variant={"primary"}
                                className={"AddCartItem"}
                              />
                            </Col>
                          </Row>
                          <div className="product-Item">
                            <Row>
                              <Col>
                                <ProductCardList onClick={addCart} data={costmoreData && costmoreData.avaliable_product_data ? costmoreData.avaliable_product_data : ""} />
                              </Col>
                            </Row>
                          </div>
                          <Row>
                            <Col>
                              <div className="ProductMemberCart">
                                <h3 className="mt-4">Current Available Passes</h3>
                                <div className="CardCarousel mt-5">
                                  <h5 className="grropCard">Recurring Membership</h5>
                                  <Row>
                                    <MemberProductCart pass={recurringPass} setValue={recuringHandler} onClick={addCart} />
                                  </Row>
                                </div>
                              </div>
                            </Col>
                          </Row>

                          <Row>
                            <Col>
                              <div className="ProductMemberCart">
                                <div className="CardCarousel mt-5">
                                  <h5 className="grropCard">Time Frame</h5>
                                  <Row>
                                    <MemberProductCart pass={timePass} setValue={timeFramHandler} onClick={addCart} />
                                  </Row>
                                </div>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <div className="ProductMemberCart">
                                <div className="CardCarousel mt-5">
                                  <h5 className="grropCard">Punch Card</h5>
                                  <Row>
                                    <MemberProductCart pass={punchPass} setValue={punchHandler} onClick={addCart} />
                                  </Row>
                                </div>
                              </div>
                            </Col>
                          </Row>

                          <Row>
                            <Col>
                              <div className="ProductMemberCart">
                                <div className="CardCarousel mt-5">
                                  <h5 className="grropCard">Recurring Punch Card</h5>
                                  <Row>
                                    <MemberProductCart pass={recurringPunch} setValue={punchHandler} onClick={addCart} />
                                  </Row>
                                </div>
                              </div>
                            </Col>
                          </Row>

                          {/* Puechasese Passes */}

                          <div className="purchaseMemberCard">
                            <Row>
                              <Col>
                                <div className="ProductMemberCart">
                                  <h3 className="mt-4">Purchased Passes</h3>
                                  <div className="CardCarousel mt-5">
                                    <h5 className="grropCard">Recurring Membership</h5>
                                    <Row>
                                      <PurchaseMembershipCard pass={purchaserecurringPass} setValue={purchaserecuringHandler} />
                                    </Row>
                                  </div>
                                </div>
                              </Col>
                            </Row>

                            <Row>
                              <Col>
                                <div className="ProductMemberCart">
                                  <div className="CardCarousel mt-5">
                                    <h5 className="grropCard">Time Frame</h5>
                                    <Row>
                                      <PurchaseMembershipCard pass={purchasetimePass} setValue={purchasetimeFramHandler} />
                                    </Row>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col>
                                <div className="ProductMemberCart">
                                  <div className="CardCarousel mt-5">
                                    <h5 className="grropCard">Punch Card</h5>
                                    <Row>
                                      <PurchaseMembershipCard pass={purchasepunchPass} setValue={purchasepunchHandler} />
                                    </Row>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </>
                        :
                        <Row style={{ textAlign: "center" }}>
                          <Col>
                            <h1>No Record </h1>
                          </Col>
                        </Row>
                      }
                    </Container>
                  </div>
                </section>
                <Footer />
              </div>
            </Col>
          </Row >

          {/* Model Start */}

          <Modal
            show={rPassDetails}
            onHide={() => {
              setRPassDetails(false);
              setCustomerData([]);
              setPaymentVal(false);
              setCardType();
              setSaveCard(0);
              setCardData({ name: "", crdNumber: "", dates: "", cvv: "" });
              setExpiryDate();
            }}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            top
          >
            <Modal.Header closeButton>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col lg={6} md={6} sm={12} className="d-flex justify-content-center">
                  <Card className="blueback-pass" style={{ maxWidth: '100%', minWidth: '90%', maxHeight: '225px' }} key={1}>
                    <div className="cardImg">
                      <Card.Img style={{ width: '100px' }} variant="top" src={passDetail?.business_logo} />
                      <p>Valid For {passDetail?.pass_validity}</p>
                    </div>
                    <Card.Body>
                      <Card.Title>{passDetail?.pass_name} </Card.Title>
                      <Card.Text>
                        {passDetail?.full_price} Plus Tax
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={6}>
                  <div class="col-12 col-lg-12 mt-5 mt-lg-0" >

                    <div class="s-d-appoint-block-right border-radius6 box-shadow1 white-bg" >
                      <div className="row px-3 pb-3 pt-3 border-bottom">
                        <div className="col-4 text-left">
                          <p style={{ fontWeight: '600', margin: 'auto' }}>Discount Code</p>
                        </div>
                        <div className="col-8">
                          <div className="row">
                            <div className="col-8 discount-box">
                              <div className="inputNumber" style={{ padding: '0px 10px' }}>
                                <input name='coupon_code'
                                  style={{
                                    width: '190px',
                                    padding: '0.1rem 0.4rem',
                                    fontSize: '12px',
                                  }}
                                  value={dCode}
                                  onChange={(event) => setDCode(event.target.value)}
                                />
                              </div>
                            </div>
                            <div className='col-4'>
                              <button
                                className="discount-button"
                                onClick={() => handleApply(passDetail)}

                              >Apply
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="px-3 py-2 text-left light-bg border-t-lr-6">
                        <h5 class="title black-color font-w-100 text-capitalize font-16 mb-0"> payment details </h5>
                      </div>
                      {/* <!-- top heading --> */}

                      <div class="px-3 pt-4 pb-2 ">
                        <div class="row mb-2">
                          <div>
                            {passDetail?.pass_type_name === 'Recurring Membership' ? (
                              <div className='row'>
                                <div className="col-6 text-left">
                                  <p className="black-color font-w-100 font-18 mb-1">Full Price</p>
                                </div>
                                <div className="col-6 text-right">
                                  <p className="black-color font-w-100 font-18 mb-1">
                                    $ {passDetail?.full_price}
                                  </p>
                                </div>
                                <div className="col-6 text-left">
                                  <p className="black-color font-w-100 font-18 mb-1">Pro-Rated Amount</p>
                                </div>
                                <div className="col-6 text-right">
                                  <p className="black-color font-w-100 font-18 mb-1">
                                    $ {parseFloat(passDetail?.amount).toFixed(2)}
                                  </p>
                                </div>

                              </div>
                            ) : (
                              <div className='row'>
                                <div className="col-6 text-left">
                                  <p className="black-color font-w-100 font-18 mb-1">
                                    Price(1 Item)
                                  </p>
                                </div>
                                <div className="col-6 text-right">
                                  <p className="black-color font-w-100 font-18 mb-1">
                                    $ {passDetail?.amount}
                                  </p>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                        {discountAmount && (
                          <div className="row mb-2">
                            <div className="col-6 text-left">
                              <p className="title black-color font-w-100 font-18 mb-1"> Total Discount </p>
                            </div>
                            <div className="col-6 text-right">
                              <p className="title black-color font-w-100 font-18 mb-1">
                                - $  {discountAmount} </p>
                            </div>
                          </div>
                        )}

                        {discountAmount && (
                          <div className="row mb-2">
                            <div className="col-6 text-left">
                              <p className="title black-color font-w-100 font-18 mb-1">   Adjust Total </p>
                            </div>
                            <div className="col-6 text-right">
                              <p className="title black-color font-w-100 font-18 mb-1">
                                $ {(Number(passDetail?.amount ?? 0) - Number(discountAmount ?? 0)).toFixed(2)}
                              </p>
                            </div>
                          </div>
                        )}
                        <div class="row">
                          <div class="col-6 text-left">
                            <p class="black-color font-w-100 font-18 mb-1"> Tax 1 </p>
                          </div>
                          <div class="col-6 text-right">
                            <p class="black-color font-w-100 font-18 mb-1"> $ {passDetail?.tax1_rate}   </p>
                          </div>
                          <div class="col-6 text-left">
                            <p class="black-color font-w-100 font-18 mb-1"> Tax 2 </p>
                          </div>
                          <div class="col-6 text-right">
                            <p class="black-color font-w-100 font-18 mb-1">$ {passDetail?.tax2_rate}  </p>
                          </div>
                        </div>
                      </div>
                      {/* <!-- end of Appointment Fees: --> */}

                      <div class="px-3 pt-2 pb-3 border-bottom">
                        <div class="row mb-2">
                          <div class="col-6 text-left">
                            <p class="title black-color font-w-100 font-18 mb-0"> Total Payable </p>
                          </div>
                          <div class="col-6 text-right">
                            <p class="title black-color font-w-100 font-18 mb-0">
                              $ {discountedAmount ?? passDetail?.pass_total_price}
                            </p>
                          </div>
                        </div>
                      </div>

                      {!paymentVal &&
                        <div class="px-3 py-3 text-center">
                          <button type="button" class="btn btn-blue-grad px-4 w-50 text-capitalize mb-0 mb-md-5 mt-2" onClick={() => { setPaymentVal(true) }}
                          > checkout </button>

                        </div>
                      }

                    </div>
                    {paymentVal &&
                      <div class="px-3 py-3 text-center" >
                        <div class="client-buy-process border-radius6 box-shadow1 white-bg mt-2" >
                          <div class="p-3 text-left light-bg border-t-lr-6">
                            <h5 class="title black-color font-w-100 text-capitalize font-16 mb-0"> credit card / debit card </h5>
                          </div>
                          <div class="px-3 pt-4 pb-3 border-bottom">
                            <div class="row mb-2">
                              <div class="col-6 text-left">
                                <p class="title black-color font-w-100 font-18 mb-0"> Total Payable </p>
                              </div>
                              <div class="col-6 text-right">
                                <p class="title black-color font-w-100 font-18 mb-0">$ {discountedAmount ?? passDetail?.pass_total_price} </p>
                              </div>
                            </div>
                          </div>

                          <div class="client-payment-input border-radius6 box-shadow1 white-bg p-4">
                            <div class="row">
                              {customerData && customerData.map((cardsave) => (
                                <div class="col-12 mb-3"  >
                                  {cardsave.length != 0 &&
                                    <div class="client-card-img white-bg border-radius6 box-shadow1">
                                      <label class="select-card select-card-img select-card-cvv mb-2">
                                        {(cardsave.card_type == 'VISA' || cardsave.card_type == 'visa') &&
                                          <img src="clientassets/img/visa_card.png" class="img-fluid payment_img" />}
                                        {cardsave.card_type == 'MC' &&
                                          <img src="clientassets/img/master_card.png" class="img-fluid payment_img" />}
                                        {cardsave.card_type == 'AM' &&
                                          <img src="clientassets/img/american_express.png" class="img-fluid payment_img" />}
                                        <p class="mb-0 font-12 dark-color mt-2">{cardsave.number}  </p>
                                        <h5 class="mb-0 font-12 dark-color mt-2">Valid Till(MM/YYYY) </h5>
                                        <p class="mb-0 font-12 dark-color mt-2">{cardsave.expiry_month}  / {cardsave.expiry_year} </p>
                                        <input type="radio" checked={cardType == cardsave.card_id} name="radio" id={cardsave.card_id} value={cardsave.card_id} onChange={(e) => getCardType(e)}
                                        />
                                        <span class="checkmark"></span>
                                      </label>
                                      {cardType == cardsave.card_id &&
                                        <form >
                                          <div class="text-center d-flex">
                                            <button type="button" class="btn btn-blue-grad w-100 text-capitalize m-3"
                                              onClick={() => savePayment(cardsave)}
                                            > Pay Now </button>
                                          </div>
                                        </form>
                                      }
                                    </div>
                                  }
                                </div>
                              ))}

                              <div class="col-12 mb-3">
                                <div class="white-bg border-radius6 box-shadow1">
                                  <label class="select-card"> New Card
                                    <input type="radio" checked={cardType == 'new'} name="radio" id="new" value="new"
                                      onChange={(e) => getCardType(e)}
                                    />
                                    <span class="checkmark"></span>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                          {cardType == 'new' &&
                            <form>
                              <div class="row py-4 px-3">
                                <div className="col-12 col-sm-6">
                                  <div className="form-group">
                                    <p className="brand-color3 text-left font-14 mb-2"> Name On Card </p>
                                    <input
                                      type="text"
                                      className="form-control"
                                      autoComplete="off"
                                      name='name'
                                      placeholder="Sophie Joe"
                                      value={cardData.name}
                                      onChange={CardInputChange}
                                    />
                                    <small className="text-danger">{cardError.name}</small>
                                  </div>
                                </div>
                                <div className="col-12 col-sm-6">
                                  <div className="form-group client-buy-input-cardno">
                                    <p className="brand-color3 text-left font-14 mb-2"> Card Number </p>
                                    <input
                                      type="text"
                                      autoComplete="off"
                                      className="form-control"
                                      placeholder="4121 4411 3131 8554"
                                      name='crnumber'
                                      value={cardData.crnumber}
                                      onChange={CardInputChange}
                                      maxLength={19}
                                    />
                                    <small className="text-danger">{cardError.crnumber}</small>
                                  </div>
                                </div>

                                <div className="col-12 col-sm-6 mt-2 mt-md-3">
                                  <div className="form-group">
                                    <p className="brand-color3 text-left font-14 mb-2"> Valid Till </p>
                                    <input
                                      type="text"
                                      name={'dates'}
                                      className="form-control"
                                      placeholder="MM/YYYY"
                                      value={expiryDate}
                                      onChange={handleInputChange}
                                      pattern="^[0-9]{2}/[0-9]{4}"
                                      autoComplete="new-password"
                                      lable={"Valid Through"}
                                    />
                                    <small className="text-danger">{cardError.dates}</small>
                                  </div>
                                </div>
                                <div className="col-12 col-sm-6 mt-2 mt-md-3">
                                  <div className="form-group">
                                    <p className="brand-color3 text-left font-14 mb-2"> CVV </p>
                                    <input
                                      type="password"
                                      autoComplete="off"
                                      className="form-control"
                                      placeholder="eg. 1234"
                                      name='cvv'
                                      value={cardData.cvv}
                                      onChange={CardInputChange}
                                      maxLength={4}
                                    />
                                    <small className="text-danger">{cardError.cvv}</small>
                                  </div>
                                </div>
                                <div class="col-12">
                                  <input type="checkbox" checked={saveCard === 1} onChange={(e) => SavecardHandeler(e)} /> Save Card
                                </div>
                                <div class="text-center d-flex">
                                  <button type="button" class="btn btn-blue-grad w-100 text-capitalize m-3"
                                    onClick={() => paymentHandler()}
                                  > Proceed to pay </button>
                                </div>
                              </div>
                            </form>
                          }
                        </div>
                      </div >
                    }
                  </div>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>

            </Modal.Footer>
          </Modal>

          {/* Model End */}
        </div >
      </div >
    </>
  );
};
